import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import {
  FDAlert,
  FDBodyText,
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import { dataAttrs } from 'Helpers/Testing';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { linterResultMetaOverrideSet, PM2JourneyPathExplorerExitLinterResult } from './linterResult';

export const PM2JourneyPathExplorerExit = () => {
  const { clearModalCollection, modalResource: resource } = useModalContext();

  const exitButton = resource.withRelationship(fr.relationships.exit.name,
    (rel) => (
      <SecondaryActionButtonRel
        relationship={rel}
        {...dataAttrs('roadmap-explorer-update-path-discard-btn')}
      />
    ),
    () => null);

  const selectOrCancelButton = resource.withRelationship(fr.relationships.select.name,
    (rel) => (
      <PrimaryActionButtonRel
        relationship={rel}
        {...dataAttrs('roadmap-explorer-update-path-select-btn')}
      />
    ),
    () => (
      <FDPrimaryActionButton
        label={resource.attr('cancelPrompt')}
        {...dataAttrs('roadmap-explorer-update-path-cancel-btn')}
        onClick={() => {
          clearModalCollection();
        }}
      />
    ));

  const linterResults = resource.attr('linterResults').resources().list();
  let content = <FDBodyText size={'md'} value={resource.attr('subTitle')} />;
  if (linterResults.length > 0) {
    content = (
      <FDStack direction={'column'}>
        <FDAlert
          status={'error'}
          title={resource.attr('errorText')}
          description={resource.attr('errorSubText')}
        />
        <ul>
          <MetaCollectionRenderer
            collection={resource.attr('linterResults')}
            layout={PM2JourneyPathExplorerExitLinterResult}
            metaOverrideSet={linterResultMetaOverrideSet}
          />
        </ul>
      </FDStack>
    );
  }

  return (
    <>
      <DialogTitle value={resource.attr('title')} />
      <DialogContent>
        <FDStack direction="column">
          {content}
          <FDStack direction={'row'} padding={4} spacing={2} justifyContent={'flex-end'}>
            {exitButton}
            {selectOrCancelButton}
          </FDStack>
        </FDStack>
      </DialogContent>
    </>
  );
};
